import { css } from '@linaria/core';

export const extendWithColumnTeaserComposition = css`
  flex-direction: column;

  .teaser-wrap {
    max-width: 100%;
  }
`;
